import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { getRecaptchaToken, isRecaptchaEnabled } from "../../utils/recaptcha";

const initialState = {
  loading: false,
  otp: "",
  error: "",
  token: "",

  generateTokenObj: {
    value: "",
    success: "",
    loading: false,
    error: "",
  },
  generateOtpObj: {
    value: "",
    success: "",
    loading: false,
    error: "",
  },
  validateOptObj: {
    value: "",
    success: "",
    loading: false,
    error: "",
  },
};

const generateToken = createAsyncThunk("token/generate", async (obj) => {
  const data = {
    mobile: obj.mobile,
    deviceId: process.env.REACT_APP_DEVICE_ID || "123456",
    brand: process.env.REACT_APP_BRAND || "DLFMALLSDEMO",
  };
  try {
    const result = await axios.post(
      "https://apac.api.capillarytech.com/auth/v1/token/generate",
      data,
      { commonHeaderNotRequired: true }
    );

    return result?.data;
  } catch (err) {
    console.log(err);
  }
});
const generateOtp = createAsyncThunk("otp/generate", async (obj) => {
  const data = {
    identifierType: "MOBILE",
    identifierValue: obj.mobile,
    deviceId: process.env.REACT_APP_DEVICE_ID || "123456",
    brand: process.env.REACT_APP_BRAND || "DLFMALLSDEMO",
    sessionId: obj.sessionId,
  };
  try {
    if (!isRecaptchaEnabled()) {
      const result = await axios.post(
        "https://apac.api.capillarytech.com/auth/v1/otp/generate",
        data,
        { commonHeaderNotRequired: true }
      );
      return result?.data;
    }

    const recaptchaToken = await getRecaptchaToken("otp_generate");
    const baseUrl =
      process.env.REACT_APP_AUTH_BASE_URL ||
      "https://productization-back-end.productization-psv-facets-psv-qa.capillary-psv.facets.cloud";

    const result = await axios.post(
      `${baseUrl}/recaptcha/auth/v1/otp/generate?profile=register`,
      data,
      {
        commonHeaderNotRequired: true,
        headers: {
          "Recaptcha-Token": recaptchaToken,
          apiKey: process.env.REACT_APP_API_KEY,
          "x-client": "webapp",
          orgId: process.env.REACT_APP_ORG_ID,
          "Content-Type": "application/json",
        },
      }
    );

    return result?.data;
  } catch (err) {
    console.log(err);
    // axios interceptor rejects with error.response; recaptcha may throw Error
    if (err?.data) {
      return {
        ...err.data,
        statusCode: err.data.statusCode || err.status,
        status: {
          success: false,
          message: err.data.message,
        },
      };
    }

    return {
      statusCode: err?.status,
      status: {
        success: false,
        message: err?.message || "Failed to generate OTP",
      },
    };
  }
});

const validateOtp = createAsyncThunk("otp/valid", async (obj) => {
  const data = {
    identifierType: "MOBILE",
    identifierValue: obj.mobile,
    deviceId: process.env.REACT_APP_DEVICE_ID || "123456",
    brand: process.env.REACT_APP_BRAND || "DLFMALLSDEMO",
    sessionId: obj.sessionId,
    // otp: 999999,
    otp: obj.otp,
  };
  try {
    const result = await axios.post(
      "https://apac.api.capillarytech.com/auth/v1/otp/validate",
      data,
      { commonHeaderNotRequired: true }
    );

    return result?.data;
  } catch (err) {
    console.log(err);
    return err;
  }
});
const otpSlice = createSlice({
  name: "otp",
  initialState,
  extraReducers: (builder) => {
    // Generate Otp
    builder.addCase(generateOtp.pending, (state) => {
      state.generateOtpObj.loading = true;
    });
    builder.addCase(generateOtp.fulfilled, (state, action) => {
      state.generateOtpObj.loading = false;
      state.generateOtpObj.value = action.payload;
      state.generateOtpObj.error = "";
    });
    builder.addCase(generateOtp.rejected, (state, action) => {
      state.generateOtpObj.loading = false;
      state.generateOtpObj.value = "";
      state.generateOtpObj.error = action.error.message;
    });

    // Generate token
    builder.addCase(generateToken.pending, (state) => {
      state.generateTokenObj.loading = true;
    });
    builder.addCase(generateToken.fulfilled, (state, action) => {
      state.generateTokenObj.loading = false;
      state.generateTokenObj.value = action.payload;
      state.generateTokenObj.error = "";
    });
    builder.addCase(generateToken.rejected, (state, action) => {
      state.generateTokenObj.loading = false;
      state.generateTokenObj.token = "";
      state.generateTokenObj.error = action.error.message;
    });
    // Validate Otp
    builder.addCase(validateOtp.pending, (state) => {
      state.validateOptObj.loading = true;
    });
    builder.addCase(validateOtp.fulfilled, (state, action) => {
      localStorage.setItem("token", action.payload?.auth?.token);
      state.validateOptObj.loading = false;
      state.validateOptObj.value = action.payload?.auth?.token;
      state.validateOptObj.error = "";
      state.validateOptObj.success = action?.payload?.status?.success;
    });
    builder.addCase(validateOtp.rejected, (state, action) => {
      state.validateOptObj.loading = false;
      state.validateOptObj.value = "";
      state.validateOptObj.error = action.error.message;
    });
  },
});

export default otpSlice.reducer;
export { generateOtp, generateToken, validateOtp };
